<!-- TODO: replace #848282 with the actual obergudt-grey variable -->
<!-- #848282 = obergudt-grey -->
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.2" y="19" x="3" width="22" height="5" fill="#848282"/>
<rect opacity="0.2" y="11" x="3" width="22" height="5" fill="#848282"/>
<rect opacity="0.2" y="3" x="3" width="22" height="5" fill="#848282"/>
</svg>
